/**
 * DECK ACTIONS (MODES.md §9) — a composer's options laid OUT on the CommandDeck's upper deck (no "+" menu to open):
 * each option is a compact Slack-style deck button — icon + short label — always visible; one that doesn't apply right
 * now is GREYED with the reason as its tooltip (never hidden, so people learn what's there). A toggle shows its state
 * (pressed = on). Same option shape as ``ComposerPlusMenu``: {id, label, short?, icon, type: toggle|action, checked?,
 * disabled?, reason?, onToggle?, onClick?}.
 */
import React from 'react';
import { DECK_ICON_BUTTON } from './CommandDeck.jsx';

export default function DeckActions({ options = [], testId = 'deck-actions' }) {
  const items = (Array.isArray(options) ? options : []).filter(Boolean);
  if (!items.length) return null;
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-0.5" data-testid={testId} role="toolbar" aria-label="Prompt options">
      {items.map((o) => {
        const Icon = o.icon;
        const on = o.type === 'toggle' && !!o.checked && !o.disabled;
        return (
          <button
            key={o.id}
            type="button"
            data-testid={`${testId}-${o.id}`}
            disabled={!!o.disabled}
            aria-pressed={o.type === 'toggle' ? !!o.checked : undefined}
            title={o.disabled ? (o.reason || o.label) : o.label}
            onClick={() => (o.type === 'toggle' ? o.onToggle?.() : o.onClick?.())}
            className={`${DECK_ICON_BUTTON} ${on ? 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100 hover:text-indigo-800' : ''}`}
          >
            {Icon ? <Icon className="h-4 w-4 shrink-0" aria-hidden /> : null}
            <span className="whitespace-nowrap">{o.short || o.label}</span>
            {o.type === 'toggle' ? (
              <span aria-hidden className={`ml-0.5 inline-block h-1.5 w-1.5 rounded-full ${on ? 'bg-indigo-600' : 'bg-gray-300'}`} />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
